import { buildModelManager } from "../builder.js";
const DefaultEvalResultSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  createdById: true,
  emailMetadata: true,
  evalSystemId: true,
  evaluationOutput: true,
  evaluationOutputRendered: { markdown: true, truncatedHTML: true },
  extractedFields: true,
  inputDocument: { url: true, mimeType: true, fileName: true },
  inputDocumentText: { markdown: true, truncatedHTML: true },
  notificationsSent: true,
  passStatus: true,
  processingError: true,
  processingStatus: true,
  qualityTier: true,
  score: true,
  sourceType: true,
  submitterEmail: true,
  updatedAt: true
};
const modelApiIdentifier = "evalResult";
const pluralModelApiIdentifier = "evalResults";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultEvalResultSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultEvalResultSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultEvalResultSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultEvalResultSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultEvalResultSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultEvalResultSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultEvalResultSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createEvalResult",
    operationReturnType: "CreateEvalResult",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: { evalResult: { required: false, type: "CreateEvalResultInput" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultEvalResultSelection
  },
  {
    type: "action",
    operationName: "bulkCreateEvalResults",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateEvalResultsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultEvalResultSelection
  },
  {
    type: "action",
    operationName: "updateEvalResult",
    operationReturnType: "UpdateEvalResult",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      evalResult: { required: false, type: "UpdateEvalResultInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultEvalResultSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateEvalResults",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateEvalResultsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultEvalResultSelection
  },
  {
    type: "action",
    operationName: "deleteEvalResult",
    operationReturnType: "DeleteEvalResult",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteEvalResults",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertEvalResult",
    operationReturnType: "UpsertEvalResult",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      evalResult: { required: false, type: "UpsertEvalResultInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateEvalResultResult": { hasReturnType: false },
      "... on UpdateEvalResultResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultEvalResultSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertEvalResults",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertEvalResultsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultEvalResultSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "evalResultGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const EvalResultManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultEvalResultSelection,
  operations
);
export {
  DefaultEvalResultSelection,
  EvalResultManager
};
//# sourceMappingURL=EvalResult.js.map
